import React from "react";
import { Icon } from "./SiteChrome";
import { locationKey } from "../lib/locations";

export default function SavedPlaces({ places, onSelect, onRemove }) {
  if (!places.length) return null;
  return (
    <div className="saved-places">
      <div className="saved-places-label">
        Your places <span>Saved on this device</span>
      </div>
      <ul>
        {places.map((place) => (
          <li key={locationKey(place)}>
            <button type="button" onClick={() => onSelect(place)}>
              <Icon name="pin" size={14} />
              <span>
                {place.name}
                <small>
                  {place.country ||
                    `${place.lat.toFixed(2)}, ${place.lon.toFixed(2)}`}
                </small>
              </span>
            </button>
            <button
              type="button"
              className="saved-place-remove"
              aria-label={`Remove ${place.name} from favorites`}
              onClick={() => onRemove(place)}
            >
              <Icon name="close" size={14} />
            </button>
          </li>
        ))}
      </ul>
    </div>
  );
}
